module.exports = __webpack_public_path__ + "media/packs/images/logo-mini-7a28c077174827ffad8096c7ab5a1dc2.svg";